import { render, staticRenderFns } from "./GlobalMission.vue?vue&type=template&id=22bbaa92&scoped=true"
import script from "./GlobalMission.vue?vue&type=script&lang=js"
export * from "./GlobalMission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bbaa92",
  null
  
)

export default component.exports